import { useParams } from "@tanstack/react-router";

import {
  Breadcrumb,
  type BreadcrumbProps,
} from "@/components/Navigation/Breadcrumb";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { useGetGroupId } from "@/routes/_staff/ids/-api";

export default function GroupIdBreadcrumb() {
  const { t } = useTranslation(defaultNS, { keyPrefix: "common.breadcrumbs" });
  const proxyUserId = useParams({
    from: "/_staff/ids/group-id/$id/_$id",
  }).id;
  const { data } = useGetGroupId(proxyUserId);

  const breadcrumbs: BreadcrumbProps[] = [
    { link: { to: "/ids" }, label: t("idManagement") },
    { label: data.loginId },
  ];

  return <Breadcrumb breadcrumbs={breadcrumbs} />;
}
